// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminData_container__2r5gt","ul":"AdminData_ul__1vAwV","title":"AdminData_title__3V3Js"};